import React from 'react'
import { useState } from 'react';
import { icons } from "../../../assets";
import { CustomModal } from '../../../components';
import { Tooltip } from 'antd';
import UserPerfilCemex from './UserPerfilCemex';
import UserPerfilMerz from './UserPerfilMerz';
import UserPerfilCemexVrl from './UserPerfilCemexVrl';
import UserPerfilSimiVR from './UserPerfilSimiVR';
import UserPerfilAmaciceFresnillo from './UserPerfilAmaciceFresnillo';
import { AddUser } from '../../VrLearning/templates/AddUser';
import UserPerfilSimiAR from './UserPerfilSimiAR';
import UserPerfilParesa from './UserPerfilParesa';

export const TemplateDetailUservt = ({ proyectId, grupo, record, nameUser, matricula, Fecha_y_hora, _idUser }) => {

    const [modalOpend, setModalOpend] = useState(false)
    const [modalEdit, setmodalEdit] = useState(false)
    return (
        <>
            <Tooltip placement="leftTop" title={<>
                <div>
                    {
                        record.tiempo_total && 
                    <div className='flex justify-start items-center hover:bg-[#3366FF33]'>
                        <img src={icons.perfil_blue} alt="" />
                                <p onClick={() => setModalOpend(true)} className="text-3366FF cursor-pointer w-[144px] pl-2 py-3">Ver perfil </p>
                    </div>
                    }
                    <div className='flex justify-start items-center hover:bg-[#3366FF33]'>
                        <img src={icons.edite_blue} alt="" />
                        <p
                            onClick={() => { setmodalEdit(true) }}
                            className="text-3366FF cursor-pointer w-[144px] pl-2 py-3">Editar</p>
                    </div>
                    {/* <div className='flex justify-start items-center hover:bg-[#3366FF33]'>
                        <img src={icons.delete_blue} alt="" />
                        <p className="text-3366FF cursor-pointer w-[144px] pl-2 py-3">Eliminar</p>
                    </div> */}
                </div>
            </>} color="#FFFFFF" overlayInnerStyle={{ color: "#3366FF" }}>
                <img

                    src={icons.moreInfo} className="w-6 cursor-pointer" alt="info" />
            </Tooltip>
            <CustomModal
                key={"usrEditing"}
                isVisible={modalEdit}
                close={() => setmodalEdit(false)}
                title={"Editar usuario"}
                width={"424px"}
                height={"472px"}
            >
                <AddUser isEditing={true} _idUser={_idUser} nameUser={nameUser} matricula={matricula} grupo={grupo} close={() => setmodalEdit(false)} >

                </AddUser>
            </CustomModal>

            <CustomModal
                key={"usrDetails"}
                isVisible={modalOpend}
                close={() => setModalOpend(false)}
                title={"Perfil de usuario"}
                width={"912px"}
                height={""}
            >
                {proyectId === "66104d3562bdb94c30339831" &&
                    <UserPerfilMerz nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilMerz>
                }
                {proyectId === "6610c73702c6d8edebbe9154" &&
                    // SIMI VR 
                    <UserPerfilSimiVR nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilSimiVR>
                }
                {proyectId === "66155e601e91fe7bde671941" &&
                    // SIMI AR 
                    <UserPerfilSimiAR nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilSimiAR>
                }
                {proyectId === "679965563ed6fed031d3b488" &&
                    // paresa
                    <UserPerfilParesa nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilParesa>
                }
                {proyectId === "66fafd1d92bbc20883798c43" &&
                    <UserPerfilCemex nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilCemex>
                }
                {proyectId === "672e4328031ac03e79f58508" &&
                    <UserPerfilCemexVrl nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilCemexVrl>
                }
                {proyectId === "67367c71fa5b23562aee086c" &&
                    <UserPerfilAmaciceFresnillo nameUser={nameUser} Fecha_y_hora={Fecha_y_hora} matricula={matricula} grupo={grupo}></UserPerfilAmaciceFresnillo>
                }
            </CustomModal>
        </>

    )

}

export default TemplateDetailUservt
